/**
 * @packageDocumentation
 * @module f1/to
 */

export interface ToString {
  /**
   * Convert any value to an string
   *
   * @public
   * @function f1.to.string
   * @param value any value
   * @example
   *
   * ```ts
   * f1.to.string(1.22) === '1.22'
   * f1.to.string(true) === 'true'
   * f1.to.string({ g: 1 }) === '{"g":1}'
   * f1.to.string(new Date()) === '"2020-07-03T02:10:27.815Z"'
   * ```
   */
  (value: unknown): string;
}

/**
 * @see ToString
 */
export default (value: unknown): string => {
  try {
    return JSON.stringify(value);
  } catch {
    return Object.prototype.toString.call(value);
  }
};
